import React, { useState } from "react";
import "../../assets/css/consult.css";
import discount from "../../assets/img/consultation.png";
import emailjs from "emailjs-com";
import { useNavigate } from "react-router-dom";

const Consult = () => {
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState("");
  const [buttonText, setButtonText] = useState("Send Message");
  const [alertType, setAlertType] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    mobileNumber: "",
  });
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validateFields = () => {
    let validationErrors = {};
    if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
      validationErrors.name = "Please enter a valid name.";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      validationErrors.email = "Please enter a valid email address.";
    }
    if (!formData.message.trim()) {
      validationErrors.message = "Message cannot be empty.";
    }
    const ukMobileRegex = /^0\d{10}$/;
    if (!ukMobileRegex.test(formData.mobileNumber)) {
      validationErrors.mobileNumber =
        "Please enter a valid 11-digit UK mobile number.";
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateFields()) return;

    setButtonText("Sending...");
    emailjs
      .sendForm(
        "service_2cnqd96",
        "template_kggtu15",
        e.target,
        "nQBJzdhm_0rQ4QbLv"
      )
      .then(
        () => {
          setAlertMessage(
            "Thank you for contacting us! Our team will be in touch soon."
          );
          setAlertType("success");
          setShowAlert(true);
          setButtonText("Send Message");
          // setShowModal(true);
          setFormData({ name: "", email: "", message: "", mobileNumber: "" });
          navigate("/thank-you");
          setErrors({});
        },
        (error) => {
          setAlertMessage("Failed to send message. Please try again.");
          setAlertType("danger");
          setShowAlert(true);
          console.error("Error during form submission:", error);
          setButtonText("Send Message");
        }
      );
  };

  return (
    <div className="container-fluid mt-5 mb-5">
      <div className="row">
        <div className="col-md-6 d-none d-lg-block left-column d-flex align-items-center"></div>

        <div className="col-md-6 right-column bg-theme d-flex justify-content-lg-end justify-content-center align-items-center">
          <div className="w-100 w-lg-75">
            <h2 className="fw-bold fs-40 mb-3">
              Get started with a <span className="text-golden">FREE</span>{" "}
              consultation
            </h2>

            <form onSubmit={handleSubmit} id="asifakhri">
              <input type="hidden" name="form_name" value="Composite Bonding" />
              <div className="mb-3">
                <input
                  type="text"
                  name="name"
                  className="form-control rounded-0"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
                {errors.name && (
                  <small className="text-golden">{errors.name}</small>
                )}
              </div>
              <div className="mb-3">
                <input
                  type="email"
                  name="email"
                  className="form-control rounded-0"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                {errors.email && (
                  <small className="text-golden">{errors.email}</small>
                )}
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  name="mobileNumber"
                  className="form-control rounded-0"
                  placeholder="Your Phone"
                  value={formData.mobileNumber}
                  onChange={handleInputChange}
                  onBlur={() => validateFields()}
                  required
                  pattern="\d{11}"
                  title="Phone number must be 11 digits"
                />
                {errors.mobileNumber && (
                  <small className="text-golden">{errors.mobileNumber}</small>
                )}
              </div>
              <div className="mb-3">
                <textarea
                  name="message"
                  className="form-control rounded-0"
                  rows="3"
                  placeholder="How can we help?"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                ></textarea>
                {errors.message && (
                  <small className="text-golden">{errors.message}</small>
                )}
              </div>
              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input fs-12 mt-2"
                  id="privacyPolicy"
                  required
                />
                <label
                  className="form-check-label fs-12"
                  htmlFor="privacyPolicy"
                >
                  Please tick this box to agree to our{" "}
                  <a
                    href="https://www.regent-dental.co.uk/privacy-policy"
                    target="_blank"
                    className="text-golden"
                  >
                    privacy policy
                  </a>{" "}
                  before continuing.
                </label>
              </div>
              <button type="submit" className="btn btn-golden border-0 w-100">
                {buttonText}
              </button>
            </form>
          </div>
        </div>

        {/* Success Modal */}
        {showModal && (
          <div
            className="modal d-block border-0"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-success text-white">
                <div className="modal-header bg-theme d-flex justify-content-end border-0">
                  <a type="button" onClick={() => setShowModal(false)}>
                    <i class="fa fa-times text-white" aria-hidden="true"></i>
                  </a>
                </div>
                <div className="modal-body bg-theme p-4 text-center">
                  <p className="fs-20">
                    <span className="text-golden">Thank you</span> for getting
                    in touch, one of the team will be in touch soon!
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Consult;
